import styled from "styled-components";
import {ProfileMessagesDividerDefaultBox} from "./profile-messages-divider.default.box";

export const ProfileMessagesDividerWsopBox = styled(ProfileMessagesDividerDefaultBox)`
    background: ${({theme}) => theme.colors.boxBorder}; /* bodyBackground, userMenuBalanceBorder */
`;
